export default __webpack_public_path__ + "static/event-startup-7de2006f478eb74b22e5281a13d58e68.jpg";